class DatePickerController {
  constructor($element) {
    'ngInject';

    this.$element = $element;
  }

  $onInit() {
    this.input = this.$element.find('input');
    this.placeholder = this.$element.attr('placeholder') ? this.$element.attr('placeholder') : 'mm/dd/yyyy' ;

    let options = {};
    options['autoclose'] = this.autoclose ? true : false;
    options['todayHighlight'] = this.todayHighlight ? true : false;
    options['format'] = this.dateFormat ? this.dateFormat : 'mm/dd/yyyy';

    this.input.datepicker(options);
    this.input.attr('name', this.$element.attr('name'));
    this.input.change((event) => {
      this.onChange(this.input.val());
    });
  }

  $doCheck() {
    this.input.val(this.ngModel.$viewValue);
  }

  onChange(value) {
    this.ngModel.$setViewValue(value);
  }

  onReset() {
    $('.datepicker_class').val('').datepicker('update');
  }

}

export default DatePickerController;



// WEBPACK FOOTER //
// ./client/app/shared/ui/datepicker/datepicker.controller.js